/**
 * This was previously defined as an inline script in each brand's HTML file.
 * Since the CSP blocks inline JavaScript, it has been moved here and included
 * in the application bundle.
 *
 * This cannot currently be removed because some dependencies may still expect
 * `global` to be available in the browser.
 *
 * Context: https://stackoverflow.com/a/73208485
 */

window.global ||= window;
